<template>
  <v-list
    class="mb-2 mt-2 pb-0 pt-0"
    two-line
  >
    <template v-for="order in orders">
      <v-list-item
        :key="`list-item-${order[fieldOrderId]}`"
        :class="isDarkMode ? 'grey darken-4' : 'grey lighten-3'"
        class="my-2 px-2 px-sm-4 d-block"
        ripple
        @click="onListTileClick(order)"
      >
        <div class="d-flex align-center">
          <div
            class="text-caption pr-2"
            style="display: grid !important;"
          >
            <v-chip
              :color="parseInt(order[fieldStatusId]) !== 19 ? 'green' : 'red'"
              :small="dense"
              class="white--text px-2 mr-1 mb-1"
              label
              style="display: inline-block; text-align: center; min-width: 110px;"
            >
              <strong>{{ '#' + order[fieldOrderCode] }}</strong>
            </v-chip>

            <div>
              <div style="position: relative;">
                <v-chip
                  :class="parseInt(order[fieldSourceTypeId]) < 100 ? 'px-2' : 'px-0'"
                  :color="parseInt(order[fieldSourceTypeId]) < 100 ? 'blue-grey' : 'transparent'"
                  :small="dense"
                  :style="parseInt(order[fieldSourceTypeId]) !== 4 ? parseInt(order[fieldSourceTypeId]) >= 100 ? 'min-width:32px; width: 32px;' : 'min-width:32px;' : 'min-width: 115px;'"
                  class="blue-grey--text text--lighten-3 mr-1 mb-1"
                  label
                  style="display: inline-block; text-align: center;"
                >
                  <v-icon
                    v-if="parseInt(order[fieldSourceTypeId]) < 100"
                    size="20"
                  >
                    {{ getOrderSourceTypeById(order[fieldSourceTypeId]).logo }}
                  </v-icon>
                  <img
                    v-else
                    :src="getOrderSourceTypeById(order[fieldSourceTypeId]).logo"
                    height="32"
                  >
                </v-chip>

                <template v-if="parseInt(order[fieldSourceTypeId]) !== 4">
                  <v-chip
                    v-if="parseInt(order[fieldOrderTypeId]) === 2"
                    :small="dense"
                    :style="parseInt(order[fieldSourceTypeId]) !== 4 ? parseInt(order[fieldSourceTypeId]) < 100 ? 'min-width: 75px;' : 'min-width: 75px; width: 80px' : 'min-width: 115px;'"
                    class="light-blue--text text--lighten-4 px-2 mr-1 mb-1"
                    color="light-blue"
                    label
                    style="display: inline-block; text-align: center;"
                  >
                    <v-icon size="20">
                      directions_run
                    </v-icon>
                    <span class="pl-2">
                      <strong>{{ convertMinutesToDisplayString(order[fieldOrderTypeTime]) }}</strong>
                    </span>
                  </v-chip>

                  <v-chip
                    v-if="parseInt(order[fieldOrderTypeId]) === 1"
                    :small="dense"
                    :style="parseInt(order[fieldSourceTypeId]) !== 4 ? parseInt(order[fieldSourceTypeId]) < 100 ? 'min-width: 75px;' : 'min-width: 75px; width: 80px' : 'min-width: 115px;'"
                    class="purple--text text--lighten-3 px-2 mr-1 mb-1"
                    color="purple"
                    label
                    style="display: inline-block; text-align: center;"
                  >
                    <v-icon size="20">
                      directions_bike
                    </v-icon>
                    <span class="pl-2">
                      <strong>{{ convertMinutesToDisplayString(order[fieldOrderTypeTime]) }}</strong>
                    </span>
                  </v-chip>
                </template>

                <v-avatar
                  v-if="order.IsScheduled"
                  color="white"
                  size="18"
                  style="position: absolute; top: -8px; right: -4px;"
                >
                  <v-icon
                    color="green"
                    size="18"
                  >
                    mdi-clock-time-four
                  </v-icon>
                </v-avatar>
              </div>

              <v-list-item-subtitle
                v-if="dense"
                class="mt-1 text-center"
                style="white-space: nowrap;"
              >
                <span style="font-size: 11px;">{{ order[fieldDateAdded] + ' - ' + order[fieldTimeAdded] }}</span>
              </v-list-item-subtitle>
            </div>
          </div>

          <v-list-item-content
            class="grey--text text--darken-1 py-0 pt-1"
            style="align-self: start;"
          >
            <slot
              :order="order"
              name="content"
            >
              <v-list-item-title
                v-if="order[fieldFullName].trim()"
                class=""
              >
                <v-icon
                  :class="[parseInt(order[fieldCustomerId]) === 0 ? 'grey--text' : 'amber--text']"
                  class="text--lighten-2 pb-1"
                  size="16"
                  style="width: 22px;"
                >
                  verified_user
                </v-icon>
                {{ order[fieldFullName] }}
              </v-list-item-title>

              <v-list-item-title
                v-else
                class="text-caption"
              >
                <v-icon
                  :class="[parseInt(order[fieldCustomerId]) === 0 ? 'grey--text' : 'amber--text']"
                  class="text--lighten-2 pb-1"
                  size="16"
                  style="width: 22px;"
                >
                  verified_user
                </v-icon>
                {{ parseInt(order[fieldCustomerId]) === 0 ? $t('Customer.CustomerType.Visitor') : $t('Customer.CustomerType.Registered') }}
              </v-list-item-title>

              <v-list-item-subtitle
                v-if="order?.Address"
                class="text-caption"
              >
                <v-icon
                  color="light-green"
                  size="16"
                  style="width: 22px;"
                >
                  location_on
                </v-icon>

                <address-display
                  :address="order?.Address"
                  class="d-inline-block ml-1"
                />
              </v-list-item-subtitle>

              <v-list-item-subtitle
                v-if="!dense"
                style="white-space: nowrap;"
              >
                <v-icon
                  color="blue"
                  size="16"
                  style="width: 22px;"
                >
                  today
                </v-icon>

                <template v-if="order.IsScheduled">
                  <span class="text-caption ml-1">{{ order['ScheduledDateAt'] + ' - ' + order['ScheduledTimeAt'] }}</span>
                </template>
                <template v-else>
                  <span class="text-caption ml-1">{{ order[fieldDateAdded] + ' - ' + order[fieldTimeAdded] }}</span>
                </template>
              </v-list-item-subtitle>
            </slot>
          </v-list-item-content>

          <v-list-item-action>
            <slot
              :order="order"
              name="actions"
            >
              <v-list-item-action-text class="text-subtitle-1">
                {{ order[fieldOrderTotal] | currency }}
              </v-list-item-action-text>
              <v-btn
                v-if="removeAction"
                color="red"
                icon
                ripple
                small
                @click.native.stop="onRemoveActionClick(order)"
              >
                <v-icon>close</v-icon>
              </v-btn>

              <v-btn
                v-if="directionsAction"
                color="blue"
                icon
                ripple
                small
                @click.native.stop="onDirectionsActionClick(order)"
              >
                <v-icon>mdi-directions</v-icon>
              </v-btn>

              <v-tooltip
                v-if="reorderAction && canEditOrder(order)"
                color="green darken-1"
                left
              >
                <template #activator="{on}">
                  <v-btn
                    v-if="reorderAction && canEditOrder(order)"
                    color="green"
                    icon
                    ripple
                    small
                    v-on="on"
                    @click.native.stop="onReOrderClick(order)"
                  >
                    <v-icon>{{ $t('Order.OrdersVList.ReOrder.Icon') }}</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('Order.OrdersVList.ReOrder.Title') }}</span>
              </v-tooltip>
            </slot>
          </v-list-item-action>
        </div>

        <div class="d-flex align-center pa-0 pb-1">
          <order-payments-chip
            :item="order"
            class="ml-0"
            dense
            hide-amount
            max-width="115"
            min-width="115"
          />
        </div>
      </v-list-item>
    </template>
  </v-list>
</template>

<script>
import AppData from '@/mixins/appdata'
import Auth from '@/mixins/auth'
import paymentType from '@/mixins/orders/paymentType'
import OrderCommon from '@/mixins/orders/common'
import OrderSourceType from '@/mixins/orders/sourceType'
import PaymentTypeEnum from '@/api/Enums/PaymentTypeEnum'
import OrderPaymentsChip from '@/components/orders/common/OrderPaymentsChip.vue'
import {getPropValueWithDotNotation} from '@/lib/helper/helper.js'
import AddressDisplay from '@/components/common/AddressDisplay.vue'

export default {
  name      : 'OrdersVList',
  components: {AddressDisplay, OrderPaymentsChip},
  directives: {},
  mixins    : [AppData, Auth, paymentType, OrderCommon, OrderSourceType],
  props     : {
    orders: {
      type    : Array,
      default : () => [],
      required: true
    },
    fieldOrderId: {
      type   : String,
      default: 'Id'
    },
    fieldOrderCode: {
      type   : String,
      default: 'OrderCode'
    },
    fieldFullName: {
      type   : String,
      default: 'FullName'
    },
    fieldCustomerId: {
      type   : String,
      default: 'CustomerId'
    },
    fieldAddressFormatted: {
      type   : String,
      default: 'AddressFormatted'
    },
    fieldPayment: {
      type   : String,
      default: 'Payment'
    },
    fieldDateAdded: {
      type   : String,
      default: 'DateAdded'
    },
    fieldTimeAdded: {
      type   : String,
      default: 'TimeAdded'
    },
    fieldOrderTotal: {
      type   : String,
      default: 'OrderTotal'
    },
    fieldStatusId: {
      type   : String,
      default: 'StatusId'
    },
    fieldOrderTypeId: {
      type   : String,
      default: 'OrderTypeId'
    },
    fieldOrderTypeTime: {
      type   : String,
      default: 'OrderTypeTime'
    },
    fieldSourceTypeId: {
      type   : String,
      default: 'SourceTypeId'
    },

    listTileClickEvent: {
      type   : String,
      default: 'list-tile-click'
    },
    removeActionClickEvent: {
      type   : String,
      default: 'remove-action-click'
    },
    directionsActionClickEvent: {
      type   : String,
      default: 'directions-action-click'
    },
    removeAction: {
      type   : Boolean,
      default: false
    },
    reorderAction: {
      type   : Boolean,
      default: false
    },
    directionsAction: {
      type   : Boolean,
      default: false
    },

    dense: {
      type   : Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  computed: {
    PaymentTypeEnum() {
      return PaymentTypeEnum
    }
  },
  watch: {},
  beforeCreate() {
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  activated() {
  },
  deactivated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {
    getPropValueWithDotNotation,

    onListTileClick(order) {
      this.$emit(this.listTileClickEvent, order)
    },

    onRemoveActionClick(order) {
      this.$emit(this.removeActionClickEvent, order)
    },

    onDirectionsActionClick(order) {
      this.$emit(this.directionsActionClickEvent, order)
    },

    onReOrderClick(order) {
      this.selectedOrder = order
      this.onEditCopy()
    }
  }
}
</script>

<style scoped>
:deep(.v-list__tile) {
  padding: 0 8px;
}

:deep(.v-chip__content) {
  padding: 0;
}
</style>
